(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-template"]) return;
  try {
    
(() => {
  let gesture = null;
  document.addEventListener('pointerdown', (event) => {
    if (event.pointerType !== 'touch' || !event.isPrimary) return;
    const image = event.target.closest('.tg-equipment .tg-gallery-image');
    gesture = image ? { image, x: event.clientX, y: event.clientY, id: event.pointerId } : null;
  }, { passive: true });
  document.addEventListener('pointercancel', () => { gesture = null; }, { passive: true });
  document.addEventListener('pointerup', (event) => {
    const start = gesture;
    gesture = null;
    if (!start || start.id !== event.pointerId) return;
    const dx = event.clientX - start.x;
    const dy = event.clientY - start.y;
    if (Math.abs(dx) < 50 || Math.abs(dy) > Math.abs(dx) / 2) return;
    const group = start.image.closest('[data-product-single-media-group]');
    const links = Array.from(group.querySelectorAll('[data-thumbnail-id]'));
    const index = links.findIndex(link => link.dataset.thumbnailId === start.image.dataset.mediaId);
    const next = links[index + (dx < 0 ? 1 : -1)];
    if (index >= 0 && next) next.click();
  }, { passive: true });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["trigonal-rattan-builder"]) return;
  try {
    
(() => {
  const initialize = (root = document) => {
    root.querySelectorAll('[data-rattan-builder]').forEach(builder => {
      if (builder.dataset.initialized) return;
      builder.dataset.initialized = 'true';
      const data = JSON.parse(builder.querySelector('[data-rb-data]').textContent);
      const q = selector => builder.querySelector(selector);
      const all = selector => builder.querySelectorAll(selector);
      const text = (selector, value) => { q(selector).textContent = value; };
      const strings = data.strings;
      const money = cents => new Intl.NumberFormat(document.documentElement.lang || 'en', {style:'currency',currency:data.currency}).format(cents / 100);
      const offer = () => q('[name="rb_offer"]:checked').value;
      const pairCount = () => offer().startsWith('2') ? 2 : 1;
      const hasTape = () => offer().endsWith('grip');
      const combination = () => q('[name="rb_combination"]:checked').value;
      const pairSizes = {
        inch: ['inch', 'inch'], slim: ['slim', 'slim'], mixed: ['inch', 'slim'],
        medium: ['medium', 'medium'], inchmedium: ['inch', 'medium'], slimmedium: ['slim', 'medium']
      };
      const singleSize = () => q('[name="rb_diameter"]:checked').value;
      const diameter = () => {
        if (pairCount() === 1) return singleSize();
        const sizes = pairSizes[combination()];
        return sizes.includes(singleSize()) ? singleSize() : sizes[0];
      };
      const diameterLabel = key => strings[key];
      const color = () => q('[name="rb_tape"]:checked').value;
      const bundleFor = (pairs, key) => data.bundles[pairs + '-' + key + '-' + color()];
      const selectedBundle = () => bundleFor(pairCount(), pairCount() === 2 ? combination() : diameter());
      const selectedComponents = () => {
        const sizes = pairCount() === 2 ? pairSizes[combination()] : [diameter()];
        const items = [];
        sizes.forEach(size => {
          const id = data.sticks[size].id;
          const item = items.find(line => line.id === id);
          if (item) item.quantity += 1;
          else items.push({id, quantity:1});
        });
        if (hasTape()) {
          const grip = Object.values(data.grips).find(g => g.title === color());
          if (!grip) return [];
          items.push({id:grip.id,quantity:1});
        }
        return items;
      };
      const selectedItems = () => hasTape() ? (selectedBundle() ? [{id:selectedBundle().id,quantity:1}] : []) : selectedComponents();
      const sources = [...Object.values(data.sticks), ...Object.values(data.grips), ...Object.values(data.bundles)];
      const available = items => items.length > 0 && items.every(item => {
        const source = sources.find(s => s.id === item.id);
        return source?.available && (!source.tracked || source.stock >= item.quantity);
      });
      let busy = false;
      let lastDiameter = '';
      const updateSubscription = () => {
        const stick = data.sticks[diameter()];
        q('[data-rb-sub-variant]').value = String(stick.id);
        const plan = stick.plans.find(p => String(p.id) === q('[data-rb-plan]').value);
        const quantity = Number(q('[data-rb-sub-qty]').value);
        text('[data-rb-sub-diameter]', strings.diameter + ': ' + diameterLabel(diameter()));
        text('[data-rb-plan-description]', plan?.description || '');
        text('[data-rb-sub-price]', plan ? money(plan.checkout * quantity) + ' ' + strings.at_checkout : '');
        text('[data-rb-per-delivery]', plan ? money(plan.perDelivery * quantity) + ' ' + strings.per_delivery : '');
        q('[data-rb-subscribe]').hidden = !stick.plans.length;
        q('[data-rb-sub-add]').disabled = busy || !plan || !Number.isInteger(quantity) || quantity < 1 || !available([{id:stick.id,quantity}]);
      };
      const update = () => {
        const key = diameter();
        const stick = data.sticks[key];
        const pairs = pairCount();
        const twoKey = combination();
        const twoRegular = pairSizes[twoKey].reduce((sum, size) => sum + data.sticks[size].price, 0);
        const tape = Object.values(data.grips).find(g => g.title === color());
        const regularRattan = pairs === 2 ? twoRegular : stick.price;
        const regular = regularRattan + (hasTape() ? tape?.price || 0 : 0);
        const total = hasTape() ? selectedBundle()?.price : regularRattan - (pairs === 2 ? data.discount : 0);
        const saving = total === undefined ? 0 : regular - total;
        text('[data-rb-one-price]', money(stick.price));
        text('[data-rb-two-price]', money(twoRegular - data.discount));
        text('[data-rb-one-grip-price]', bundleFor(1,key) ? money(bundleFor(1,key).price) : strings.unavailable);
        text('[data-rb-two-grip-price]', bundleFor(2,twoKey) ? money(bundleFor(2,twoKey).price) : strings.unavailable);
        text('[data-rb-selection]', pairs === 2 ? strings.two_pairs : strings.one_pair);
        text('[data-rb-diameter-summary]', pairs === 2 ? q('[name="rb_combination"]:checked').nextElementSibling.textContent : diameterLabel(key));
        text('[data-rb-grip-summary]', hasTape() ? (color() === 'Black' ? strings.black_grip : strings.white_grip) : '');
        q('[data-rb-grip-summary]').hidden = !hasTape();
        text('[data-rb-regular]', money(regular));
        text('[data-rb-saving]', money(saving));
        text('[data-rb-total]', total === undefined ? strings.unavailable : money(total));
        q('[data-rb-regular-row]').hidden = false;
        q('[data-rb-saving-row]').hidden = saving === 0;
        const host = q('[data-rb-offer="' + offer() + '"] [data-rb-config-host]');
        if (q('[data-rb-config]').parentElement !== host) host.append(q('[data-rb-config]'));
        q('[data-rb-config]').hidden = false;
        q('[data-rb-single-controls]').hidden = pairs !== 1;
        q('[data-rb-pair-controls]').hidden = pairs !== 2;
        q('[data-rb-tape-controls]').hidden = !hasTape();
        const inStock = available(selectedItems()) && available(selectedComponents());
        q('[data-rb-add]').disabled = busy || !inStock;
        text('[data-rb-add]', busy ? strings.adding : inStock ? strings.add : strings.unavailable);
        all('[data-rb-gallery]').forEach(el => {el.hidden = el.dataset.rbGallery !== key;});
        all('[data-rb-detail]').forEach(el => {el.hidden = el.dataset.rbDetail !== key;});
        if (lastDiameter !== key) {
          const previousPlan = q('[data-rb-plan]').value;
          q('[data-rb-plan]').replaceChildren(...stick.plans.map(plan => new Option(plan.name, String(plan.id))));
          if (stick.plans.some(p => String(p.id) === previousPlan)) q('[data-rb-plan]').value = previousPlan;
          q('[data-rb-sub-qty]').value = '1';
          lastDiameter = key;
        }
        updateSubscription();
      };
      const add = async (items, errorElement) => {
        if (busy || !available(items)) return;
        errorElement.hidden = true;
        busy = true;
        update();
        try {
          const subscription = items.length === 1 && items[0].selling_plan;
          const body = subscription ? new URLSearchParams({id:String(items[0].id),quantity:String(items[0].quantity),selling_plan:String(items[0].selling_plan)}) : JSON.stringify({items});
          const contentType = subscription ? 'application/x-www-form-urlencoded;charset=UTF-8' : 'application/json';
          const response = await fetch(data.cartAdd, {method:'POST',credentials:'same-origin',headers:{'Content-Type':contentType,Accept:'application/json'},body});
          const result = await response.json();
          if (!response.ok || result.status) throw new Error(result.description || strings.add_error);
          window.location.assign(data.cartUrl);
        } catch (error) {
          errorElement.textContent = error.message || strings.add_error;
          errorElement.hidden = false;
          busy = false;
          update();
        }
      };
      q('[data-rb-order]').addEventListener('change', event => {
        q('[data-rb-error]').hidden = true;
        if (event.target.name === 'rb_diameter') q('[name="rb_combination"][value="' + event.target.value + '"]').checked = true;
        if (event.target.name === 'rb_combination') q('[name="rb_diameter"][value="' + diameter() + '"]').checked = true;
        update();
      });
      q('[data-rb-order]').addEventListener('submit', event => {event.preventDefault();event.stopImmediatePropagation();add(selectedItems(), q('[data-rb-error]'));}, true);
      q('[data-rb-sub-order]').addEventListener('change', updateSubscription);
      q('[data-rb-subscribe]').addEventListener('toggle', () => {if (q('[data-rb-subscribe]').open) {q('[data-rb-sub-qty]').value = '1';updateSubscription();}});
      q('[data-rb-sub-order]').addEventListener('submit', event => {
        event.preventDefault();event.stopImmediatePropagation();
        const stick = data.sticks[diameter()];
        const plan = stick.plans.find(p => String(p.id) === q('[data-rb-plan]').value);
        const quantity = Number(q('[data-rb-sub-qty]').value);
        if (!plan || !Number.isInteger(quantity) || quantity < 1) return;
        add([{id:stick.id,quantity,selling_plan:plan.id}], q('[data-rb-sub-error]'));
      }, true);
      all('[data-rb-thumb]').forEach(button => button.addEventListener('click', () => {
        const gallery = button.closest('[data-rb-gallery]');
        gallery.querySelectorAll('[data-rb-image]').forEach(el => {el.hidden = el.dataset.rbImage !== button.dataset.rbThumb;});
        gallery.querySelectorAll('[data-rb-thumb]').forEach(el => {el.setAttribute('aria-pressed', String(el === button));});
      }));
      const initial = Object.entries(data.bundles).find(([,bundle]) => String(bundle.id) === builder.dataset.initialBundle);
      if (initial && q('[name="rb_combination"][value="' + initial[0].split('-')[1] + '"]')) {
        const [pairs,key,tape] = initial[0].split('-');
        q('[name="rb_offer"][value="' + pairs + '-grip"]').checked = true;
        q('[name="rb_combination"][value="' + key + '"]').checked = true;
        q('[name="rb_diameter"][value="' + pairSizes[key][0] + '"]').checked = true;
        q('[name="rb_tape"][value="' + tape + '"]').checked = true;
      }
      window.addEventListener('pageshow', () => {busy = false; update();});
      update();
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize());
  else initialize();
  document.addEventListener('shopify:section:load', event => initialize(event.target));
})();

  } catch(e) { console.error(e); }
})();
})();
